module.exports = __webpack_public_path__ + "img/flash2.ffbfea3e.jpg";